var _defs, _text, _text2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogotrial01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "blacks",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 648 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-family:BiondiSansLt-Regular, 'Biondi Sans';font-size:37.1px;}.cls-1,.cls-2,.cls-3{fill:#000;}.cls-4{letter-spacing:0em;}.cls-2{stroke-width:0px;}.cls-5{letter-spacing:0em;}.cls-3{font-family:Georgia-Bold, Georgia;font-size:60.8px;font-weight:700;letter-spacing:0em;}.cls-6{letter-spacing:0em;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:0em;}.cls-9{letter-spacing:0em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(160.6 95.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HOME - TRUST"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(163 142.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "LIVING T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 164.1,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 190.8,
    y: 0
  }, "U"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 220.3,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 244.5,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 269,
    y: 0
  }, "S"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.4 27.1 125.8 55.8 125.8 76.9 102.1 77.7 102.1 153.7 30.9 153.7 11 135.1 11 127.9 30.4 127.5 30.4 100.5 57.4 100.5 57.4 125.8 79.3 125.8 79.3 49.9 99.6 49.9 100.4 27.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.1,
    y: 51.6,
    width: 24.1,
    height: 24.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotrial01);
export default __webpack_public_path__ + "static/media/logo trial-01.0fea48f6038d55cefb31173dae7ed0c0.svg";
export { ForwardRef as ReactComponent };